import posthog from "posthog-js";

export function identifyPosthogUser(user) {
  if (!user?.id) return;
  const wantedId = String(user.id);

  if (posthog.__identifiedUserId === wantedId) return;

  const currentDistinct = posthog.get_distinct_id?.();
  if (currentDistinct !== wantedId) {
    posthog.identify(wantedId, {
      email: user.email,
      name: `${user.firstName || ""} ${user.lastName || ""}`.trim(),
      firstName: user.firstName,
      lastName: user.lastName,
      role: user.role,
      storeIds: user.storeIds,
    });
  }

  posthog.__identifiedUserId = wantedId;
}
